import { apiGet, apiDelete, apiPost, apiPut } from './api_call/api_methods'

export const fetchOrganization = async (organizationGuid) => {
    return apiGet({ endpoint: `${process.env.REACT_APP_API_URL}/organizations/${organizationGuid}`, error_message: "Failed to fetch organization" });
};

export const fetchOrganizations = async () => {
    return apiGet({ endpoint: `${process.env.REACT_APP_API_URL}/organizations`, error_message: "Failed to fetch organization" });
};

export const deleteOrganization = async (orgId) => {
    return apiDelete({ endpoint: `${process.env.REACT_APP_API_URL}/organizations/${orgId}`, successMessage: "Organisation deleted!", error_message: "Failed to delete organization" });
};

export const createOrganization = async (orgData) => {
    return apiPost({ endpoint: `${process.env.REACT_APP_API_URL}/organizations`, body: orgData, successMessage: "Organisation added!", errorMessage: "Failed to add organisation" })
};

export const updateOrganization = async (orgId, orgData) => {
    return apiPut({ endpoint: `${process.env.REACT_APP_API_URL}/organizations/${orgId}`, body: orgData, successMessage: "Organisation updated!", errorMessage: "Failed to update organisation" })
};

export const SendFamilyOrgEmailInvite = async (email, orgName) => {
    return apiGet({ endpoint: `${process.env.REACT_APP_API_URL}/send_family_org_email?email=${email}&org_name=${orgName}`, successMessage: "", errorMessage: "" })
};